/* eslint-disable react-hooks/exhaustive-deps */
import { FilterList } from "@material-ui/icons";
import { CgArrowsExchangeAltV, CgArrowUp } from "react-icons/cg";
import { flexRender } from "@tanstack/react-table";
import React, { useEffect, useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import disableScroll from "disable-scroll";
import { apiLoadFilteredRowIds } from "src/api";
import safeLogger from "src/services/safeLogger";
import { useSnackbar } from "notistack";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import {
  Box,
  Button,
  Checkbox,
  colors,
  FormGroup,
  makeStyles,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  HandleApplyFiltersComponent,
  SelectFilterHead,
} from "../../virtualizedTable/selectFilterHead";
import { Rating } from "@material-ui/lab";
import { VirtualizedAutocomplete } from "../../virtualizedTable/autoComplete";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { getTranslated, isEmpty } from "../../utils/helpers";
// import Filter from "./Filter";
import HeaderInfoButton from "./headerInfoButton";
import { SharedVariants } from "../../virtualizedTable/tooltipTableCell";
import externalFilters from "../../externalFilters";

const useStyle = makeStyles((theme) => ({
  applyFiltersBtn: {
    color: theme.palette.common.white,
    background: colors.green[400],
    "&:hover": {
      background: colors.green[600],
    },
  },
  sliderMenu: {
    "& ul": {
      width: "400px",
    },
  },
  filtered: {
    color: "pink !important",
    backgroundColor: "",
  },
  slider: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "60px 30px 30px",
    "& .MuiSlider-valueLabel > span": {
      width: "50px !important",
      height: "50px !important",
      transform: "rotate(-45deg) translate(12%, -38%)",
    },
  },
  autocompleteMenuItem: {
    "& .menuItemCheckBox": { marginRight: "1px" },
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& .resize-triggers": {
      width: "100%",
    },
  },

  "red[900]": {
    color: colors.red[900],
    "& .MuiInputBase-input": {
      color: colors.red[900],
    },
  },
  "red[500]": {
    color: colors.red[600],
    "& .MuiInputBase-input": {
      color: colors.red[600],
    },
  },
  "yellow[600]": {
    color: colors.orange[400],
    "& .MuiInputBase-input": {
      color: colors.orange[400],
    },
  },
  "amber[500]": {
    color: colors.orange[600],
    "& .MuiInputBase-input": {
      color: colors.orange[600],
    },
  },
  "orange[500]": {
    color: colors.orange[900],
    "& .MuiInputBase-input": {
      color: colors.orange[900],
    },
  },
  "green[500]": {
    color: theme.palette.success.dark,
    "& .MuiInputBase-input": {
      color: theme.palette.success.dark,
    },
  },
  "lightGreen[500]": {
    color: theme.palette.success.light,
    "& .MuiInputBase-input": {
      color: theme.palette.success.light,
    },
  },
  starRating: {
    verticalAlign: "middle",
    marginRight: theme.spacing(1),
  },
  boolean: {},
  sliderTextField: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
    gap: theme.spacing(0.2),
  },
  stepButtons: {
    paddingRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
  },
  activeButton: {
    backgroundColor: colors.green[400],
  },
  sliderThumb: {
    "&.MuiSlider-valueLabel": {
      width: "45px !important",
      height: "45px !important",
      transform: "rotate(-45deg) translate(10%, -28%)",
    },
  },
  rangeFilterContainer: {
    padding: theme.spacing(2),
    width: "100%",
  },
  inputContainer: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  numberInput: {
    width: "100%",
  },
  helperText: {
    color: theme.palette.text.disabled,
    fontSize: "0.75rem",
    marginTop: "4px",
    textAlign: "left",
  },
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "45%",
  },
  applyButton: {
    marginTop: theme.spacing(2),
    backgroundColor: colors.green[500],
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: colors.green[700],
    },
  },
}));

const Header = React.memo(function Header({
  filters,
  setCheckedRows,
  checkedRows,
  header,
  colDetails,
  reportId,
  setColDetails,
  columnHelper,
  tableKind,
  isHaventCheckbox,
  appConf,
  table,
  dynamicRowCount,
  index,
}) {
  const advanceFilter = useSelector((state) => state.advanceFilter);
  const [orderBy, setOrderBy] = React.useState(
    filters.tableSortState[header.id]
      ? filters.tableSortState[header.id] === "ASC"
        ? 2
        : 3
      : 1,
  );
  const tmpColDetails = columnHelper[header.column.id];
  const columnResizeMode = "onChange";

  const orderHandler = () => {
    switch (orderBy) {
      case 1:
        filters.setTableSortState({
          ...filters.tableSortState,
          [header.id]: "ASC",
        });
        setOrderBy((prev) => prev + 1);
        break;
      case 2:
        filters.setTableSortState({
          ...filters.tableSortState,
          [header.id]: "DESC",
        });
        setOrderBy((prev) => prev + 1);
        break;
      case 3:
        delete filters.tableSortState[header.id];
        filters.setTableSortState({ ...filters.tableSortState });
        setOrderBy(1);
        break;
      default:
        setOrderBy(1);
        break;
    }
  };

  const getItemStyle = (isDragging, draggableStyle) => {
    if (!isDragging) {
      disableScroll.off();
    } else {
      disableScroll.on();
    }
    delete draggableStyle.zIndex;
    return {
      ...draggableStyle,
      zIndex: isDragging ? "99999 !important" : "2px !important",
      // change background colour if dragging
      // backgroundColor: isDragging ? "lightgreen" : "#388e3c",
      color: isDragging ? "black" : "white",

      // styles we need to apply on draggables
    };
  };

  if (!colDetails[tmpColDetails?.globalIndex]) {
    return;
  }
  if (colDetails[tmpColDetails.globalIndex].filterValues === undefined) {
    colDetails[tmpColDetails.globalIndex].filterValues = {};
  }

  return (
    <Draggable key={index} draggableId={String(index)} index={index}>
      {(provided, snapshot) => (
        <div
          style={{
            height: "content-fit",
            color: "white",
            whiteSpace: "nowrap",
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            textOverflow: "clip",
            justifyContent: "space-between",
            flexBasis: 200,
            alignItems: "center",
          }}
        >
          {index === 0 && !isHaventCheckbox && (
            <div>
              <HeaderCheckbox
                colDetails={columnHelper}
                setCheckedRows={setCheckedRows}
                checkedRows={checkedRows}
                reportId={reportId}
                totalRowCount={dynamicRowCount}
                sortState={filters.tableSortState}
                filterState={filters.tableFilterState}
              />
            </div>
          )}
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(snapshot.isDragging, {
              ...provided.draggableProps.style,
              whiteSpace: "nowrap",
            })}
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {(!advanceFilter ||
              Object.keys(advanceFilter)?.length <= 0 ||
              advanceFilter?.rules.length <= 0) && (
              <div
                onClick={(event) => {
                  event.stopPropagation();
                  orderHandler();
                }}
                style={{
                  cursor: "pointer",
                  fontSize: 24,
                  display: "flex",
                  transition: "all 0.3s ease",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                  transform: `rotate(${
                    filters.tableSortState[header.id] === "ASC" ? `0` : `180deg`
                  })`,
                }}
              >
                {!filters.tableSortState[header.id] ? (
                  <CgArrowsExchangeAltV />
                ) : (
                  <CgArrowUp />
                )}
              </div>
            )}
            <div
              onMouseDown={header.getResizeHandler()}
              onClick={(event) => event.preventDefault()}
              onMouseUp={(event) => event.preventDefault()}
              onTouchStart={header.getResizeHandler()}
              className={`resizer ${
                header.column.getIsResizing() ? "isResizing" : ""
              }`}
              style={{
                transform:
                  columnResizeMode === "onEnd" && header.column.getIsResizing()
                    ? `translateX(${
                        table.getState().columnSizingInfo.deltaOffset
                      }px)`
                    : "",
              }}
            ></div>
            {tmpColDetails &&
              (!advanceFilter ||
                Object.keys(advanceFilter)?.length <= 0 ||
                advanceFilter?.rules.length <= 0) && (
                <HeaderFilter
                  columns={colDetails}
                  label={tmpColDetails.label}
                  name={tmpColDetails.name}
                  setColumns={setColDetails}
                  columnIndex={tmpColDetails.globalIndex}
                  appConf={appConf}
                  filterState={filters.tableFilterState}
                  tableKind={tableKind ?? "variant"}
                  filterType={
                    tmpColDetails?.kind === "numeric"
                      ? "range"
                      : Object.keys(tmpColDetails.filterValues).length > 15
                        ? "search"
                        : colDetails[tmpColDetails.globalIndex]?.kind ===
                            "boolean"
                          ? "boolean"
                          : colDetails[tmpColDetails.globalIndex]?.kind ===
                              "indexed_dictionary"
                            ? "search"
                            : "select"
                  }
                />
              )}
            <div>
              {tmpColDetails.representation.help && (
                <HeaderInfoButton
                  helpDesc={
                    i18next.language === "en"
                      ? tmpColDetails.description.en
                      : tmpColDetails.description[1]
                  }
                  // title={tmpColDetails.representation.title}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
});

export const HeaderCheckbox = React.memo((props) => {
  const {
    type,
    rowIds,
    checkedRows,
    setCheckedRows,
    totalRowCount,
    filterState,
    sortState,
    reportId,
    colDetails,
  } = props;
  const advanceFilter = useSelector((state) => state.advanceFilter);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const clickHandler = async (event) => {
    event.stopPropagation();
    if (checkedRows.length === 0) {
      if (type === "members") {
        setCheckedRows(rowIds);
      } else {
        safeLogger(filterState);
        if (
          !(
            advanceFilter &&
            Object.keys(advanceFilter).length &&
            advanceFilter.rules.length > 0
          ) &&
          (!filterState || Object.keys(filterState).length === 0)
        ) {
          const checkedTmp = [];
          for (let i = 0; i <= totalRowCount; i++) {
            checkedTmp.push(i);
          }
          setCheckedRows(checkedTmp);
        } else {
          let tmpFilterState = {
            combinator: "and",
            rules: [],
          };
          if (
            Object.keys(filterState).length ||
            (Object.keys(advanceFilter).length &&
              advanceFilter.rules.length > 0)
          ) {
            if (!advanceFilter) {
              await Object.entries(filterState).map(async (filter) => {
                const name = filter[0];
                const values = filter[1];
                if (
                  colDetails[name].kind === "enumeration" ||
                  colDetails[name].kind === "large_enum"
                ) {
                  tmpFilterState.rules.push({
                    field: name,
                    operator: "in",
                    // value must be string
                    value: values.join(","),
                  });
                } else if (colDetails[name].kind === "numeric") {
                  await values.forEach((value, index) => {
                    tmpFilterState.rules.push({
                      field: name,
                      operator: index === 0 ? ">=" : "<=",
                      // value must be string
                      value: value.toString(),
                    });
                  });
                } else if (colDetails[name].kind === "boolean") {
                  tmpFilterState.rules.push({
                    field: name,
                    operator: "=",
                    // value must be string
                    value: values,
                  });
                }
              });
            } else {
              tmpFilterState = advanceFilter;
            }
          }
          // TODO make api call to get the row ids
          apiLoadFilteredRowIds(
            reportId,
            {
              filters: tmpFilterState,
              ordering: sortState,
            },
            (data, status) => {
              if (status === 200) {
                setCheckedRows(data.rows);
              } else {
                enqueueSnackbar(
                  t(
                    "There was an error while selecting the rows. Please try again.",
                  ),
                  {
                    variant: "error",
                  },
                );
              }
            },
          );
        }
      }
    } else {
      setCheckedRows([]);
    }
  };

  return (
    <Checkbox
      color="primary"
      style={{ color: "white" }}
      indeterminate={
        checkedRows.length > 0 && checkedRows.length !== totalRowCount
      }
      checked={checkedRows.length > 0}
      onClick={clickHandler}
    />
  );
});

export default Header;

const HeaderFilter = ({
  appConf,
  label,
  name,
  columns,
  setColumns,
  filterState,
  columnIndex,
  tableKind,
  filterType,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [radioValue, setRadioValue] = useState({});
  const [autoCompleteValue, setAutoCompleteValue] = useState(
    Array.isArray(filterState[columns[columnIndex].name])
      ? filterState[columns[columnIndex].name]
      : [],
  );
  const classes = useStyle();
  const [rangeStep, setRangeStep] = useState(0.05);
  const [activeRange, setActiveRange] = useState([
    columns[columnIndex].filterRange
      ? columns[columnIndex].filterRange[0]
      : columns[columnIndex].minValue,
    columns[columnIndex].filterRange
      ? columns[columnIndex].filterRange[1]
      : columns[columnIndex].maxValue,
  ]);

  useEffect(() => {
    setActiveRange([
      columns[columnIndex].filterRange
        ? columns[columnIndex].filterRange[0]
        : columns[columnIndex].minValue,
      columns[columnIndex].filterRange
        ? columns[columnIndex].filterRange[1]
        : columns[columnIndex].maxValue,
    ]);
  }, [columns[columnIndex].filterRange]);

  const [tmpColumns, setTmpColumns] = useState(columns);
  const { t } = useTranslation();

  useEffect(() => {
    setTmpColumns([...columns]);
  }, [columns]);

  const tmpColumnIndex = tmpColumns.findIndex((val) => val.name === name);

  useEffect(() => {
    let mounted = true;
    if (filterType === "range") {
      if (
        columns[columnIndex]?.filterRange &&
        Array.isArray(columns[columnIndex]?.filterRange) &&
        columns[columnIndex]?.filterRange?.length >= 2 &&
        columns[columnIndex]?.filterRange[1] -
          columns[columnIndex]?.filterRange[0] <
          10
      ) {
        if (mounted) {
          setRangeStep(
            (columns[columnIndex]?.filterRange[1] -
              columns[columnIndex]?.filterRange[0]) /
              20,
          );
        }
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  const handleApplyRange = (newValue) => {
    const newColDetails = JSON.parse(JSON.stringify(columns));
    const tmpValues = [];
    if (
      newValue[0] !== newColDetails[columnIndex].minValue ||
      newValue[1] !== newColDetails[columnIndex].maxValue
    ) {
      newColDetails[columnIndex].activeFilterCount++;
    } else {
      newColDetails[columnIndex].activeFilterCount--;
    }

    Object.entries(radioValue).forEach((e) => {
      if (e && e[1]) {
        tmpValues.push(e[0]);
      }
    });

    newColDetails[columnIndex].filterRange = [...newValue, ...tmpValues];

    setActiveRange([...newValue]);
    setColumns([...newColDetails]);
  };

  const handleSelectAll = () => {
    const newColDetails = JSON.parse(JSON.stringify(tmpColumns));

    if (
      !newColDetails[columnIndex].activeFilterCount ||
      (newColDetails[columnIndex].activeFilterCount &&
        newColDetails[columnIndex].activeFilterCount !==
          Object.keys(newColDetails[columnIndex].filterValues).length)
    ) {
      const newAutocompleteValues = [];
      for (let item in newColDetails[columnIndex].filterValues) {
        newAutocompleteValues.push(item);
        if (!newColDetails[columnIndex].filterValues[item]) {
          newColDetails[columnIndex].filterValues[item] = true;
          newColDetails[columnIndex].activeFilterCount++;
        }
      }
      if (filterType === "search") {
        setAutoCompleteValue(newAutocompleteValues);
      }
    } else {
      for (let item in newColDetails[columnIndex].filterValues) {
        newColDetails[columnIndex].filterValues[item] = false;
      }
      newColDetails[columnIndex].activeFilterCount = 0;
      if (filterType === "search") {
        setAutoCompleteValue([]);
      }
    }

    setTmpColumns(newColDetails);
    // setColumns(newColDetails);
    // handleClose();
  };

  const handleSelect = (event, item) => {
    event.stopPropagation();

    const newColDetails = JSON.parse(JSON.stringify(tmpColumns));

    if (!newColDetails[columnIndex].filterValues[item]) {
      newColDetails[columnIndex].activeFilterCount++;
    } else {
      newColDetails[columnIndex].activeFilterCount--;
    }

    newColDetails[columnIndex].filterValues[item] =
      !newColDetails[columnIndex].filterValues[item];

    setTmpColumns(newColDetails);
    // setColumns(newColDetails);
    // handleClose();
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
      setTmpColumns([...columns]);
      if (filterState[columns[columnIndex].name]) {
        filterState[columns[columnIndex].name].forEach((item) => {
          if (item in columns[columnIndex].filterValues) {
            columns[columnIndex].filterValues[item] = true;
          }
        });
      }
      if (filterType === "search") {
        const newAutocompleteValues = [];
        for (let item in columns[columnIndex].filterValues) {
          if (columns[columnIndex].filterValues[item]) {
            newAutocompleteValues.push(item);
          }
        }
        setAutoCompleteValue(newAutocompleteValues);
      }
    }
    setAnchorEl(null);
  };

  const geneState = useSelector((state) => state.activeGeneFiltersVariant);

  const handleApplyFilters = () => {
    setColumns([...tmpColumns]);
    handleClose();
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleRadioChange = (event, value) => {
    event.stopPropagation();

    const newColDetails = JSON.parse(JSON.stringify(tmpColumns));
    if (
      event.target.checked &&
      newColDetails[columnIndex].filterValues[event.target.name] === undefined
    ) {
      newColDetails[columnIndex].filterValues = {
        ...newColDetails[columnIndex].filterValues,
        [event.target.value]: true,
      };
      newColDetails[columnIndex].activeFilterCount++;
    } else if (event.target.checked) {
      newColDetails[columnIndex].filterValues[event.target.name] = true;
      newColDetails[columnIndex].activeFilterCount++;
    } else {
      newColDetails[columnIndex].filterValues[event.target.name] = false;
      delete newColDetails[columnIndex].filterValues[event.target.name];
      if (newColDetails[columnIndex].activeFilterCount <= 0) {
        newColDetails[columnIndex].activeFilterCount = 0;
      } else {
        newColDetails[columnIndex].activeFilterCount--;
      }
    }

    setRadioValue((prev) => ({
      ...prev,
      [event.target.value]: event.target.checked,
    }));

    setTmpColumns(newColDetails);
    // setColumns(newColDetails);
    // handleClose();
  };

  const handleAutocompleteChange = (event, activeValues, option) => {
    const newColDetails = JSON.parse(JSON.stringify(tmpColumns));
    const filterKeys = Object.keys(newColDetails[columnIndex].filterValues);
    for (let i = 0; i < filterKeys.length; i++) {
      if (
        activeValues.includes(filterKeys[i]) &&
        !newColDetails[columnIndex].filterValues[filterKeys[i]]
      ) {
        newColDetails[columnIndex].filterValues[filterKeys[i]] = true;
        newColDetails[columnIndex].activeFilterCount++;
        continue;
      } else if (
        !activeValues.includes(filterKeys[i]) &&
        newColDetails[columnIndex].filterValues[filterKeys[i]]
      ) {
        newColDetails[columnIndex].filterValues[filterKeys[i]] = false;
        newColDetails[columnIndex].activeFilterCount--;
        continue;
      }
    }
    setTmpColumns([...newColDetails]);
    // setColumns(newColDetails);
    setAutoCompleteValue(activeValues);
  };

  const checkboxHandle = (isChecked) => {
    setTmpColumns((prev) => {
      prev[columnIndex].filterType = isChecked;
      return [...prev];
    });
    // handleApplyRange({ stopPropagation: () => {} }, activeRange);
  };

  useEffect(() => {
    if (filterType === "search") {
      const newAutocompleteValues = [];
      if (filterState[columns[columnIndex].name]) {
        newAutocompleteValues.push(...filterState[columns[columnIndex].name]);
      }
      setAutoCompleteValue(newAutocompleteValues);
    }
  }, [geneState, anchorEl]);

  const handleRangeChange = (event, newValue) => {
    event.stopPropagation();
    setActiveRange(newValue);
  };

  const handleBoolean = (e, column, value) => {
    e.preventDefault();
    e.stopPropagation();
    column.filterValues = value;
    let hasAnyFilter = false;
    for (const item in value) {
      if (value[item]) {
        hasAnyFilter = true;
      }
    }
    if (hasAnyFilter) {
      column.activeFilterCount++;
    } else {
      column.activeFilterCount--;
    }
    setTmpColumns([...tmpColumns]);
  };

  const handleSelectFilteredAll = (value) => {
    const newColDetails = JSON.parse(JSON.stringify(tmpColumns));
    let newAutocompleteValues = autoCompleteValue;
    let filters = {};
    for (let item in newColDetails[columnIndex].filterValues) {
      if (item.toLowerCase().includes(value))
        filters = { ...filters, [item]: false };
    }
    for (let item in filters) {
      if (
        newColDetails[columnIndex].filterValues[item] &&
        !(newColDetails[columnIndex].filterValues[item] in filters)
      ) {
        newColDetails[columnIndex].filterValues[item] = false;
        newColDetails[columnIndex].activeFilterCount--;
        newAutocompleteValues = newAutocompleteValues.filter(
          (filter) => !filter.includes(item),
        );
      } else {
        newAutocompleteValues.push(item);
        if (!newColDetails[columnIndex].filterValues[item]) {
          newColDetails[columnIndex].filterValues[item] = true;
          newColDetails[columnIndex].activeFilterCount++;
        }
      }
    }
    if (filterType === "search") {
      setAutoCompleteValue(newAutocompleteValues);
    }

    setTmpColumns(newColDetails);
  };

  // Related with line 1152-1209
  // const handleRangeChangeTextField = (event, newValue) => {
  //   event.stopPropagation();
  //   const newColDetails = JSON.parse(JSON.stringify(columns));
  //   const tmpValues = [];

  //   if (
  //     newValue !==
  //     newColDetails[columnIndex][event.name === "max" ? "maxValue" : "minValue"]
  //   ) {
  //     newColDetails[columnIndex].activeFilterCount++;
  //   } else {
  //     newColDetails[columnIndex].activeFilterCount--;
  //   }

  //   Object.entries(radioValue).forEach((e) => {
  //     if (e && e[1]) {
  //       tmpValues.push(e[0]);
  //     }
  //   });

  //   let minOrMaxValue;

  //   if (event.target.name === "max") {
  //     minOrMaxValue = [
  //       newColDetails[columnIndex].filterRange[0] === "NaN"
  //         ? newColDetails[columnIndex].maxValue
  //         : newColDetails[columnIndex].filterRange[0],
  //       event.target.value,
  //     ];
  //   } else {
  //     minOrMaxValue = [
  //       event.target.value,
  //       newColDetails[columnIndex].filterRange[1] === "NaN"
  //         ? newColDetails[columnIndex].minValue
  //         : newColDetails[columnIndex].filterRange[1],
  //     ];
  //   }
  //   newColDetails[columnIndex].filterRange = minOrMaxValue;

  //   // setColumns([...newColDetails]);
  //   setActiveRange([...minOrMaxValue]);
  // };

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {columns[columnIndex].type !== "nofilter" &&
          columns[columnIndex]?.kind !== "free_form" && (
            <div
              className={clsx("filter-button-wrapper", {
                [classes.cnvFilterButton]: tableKind === "cnv",
              })}
            >
              <Button
                aria-controls="filter-menu-button"
                aria-haspopup="true"
                style={{ padding: 0, minWidth: 35, color: "white" }}
                onClick={handleClick}
              >
                <FilterList
                  className={clsx({
                    [classes.filtered]:
                      filterState &&
                      Object.keys(filterState).includes(
                        columns[columnIndex].name,
                      ),
                  })}
                  style={{
                    color: filterState[columns[columnIndex].name]
                      ? colors.grey[500]
                      : "white",
                    dropShadow: "3.4px 6.7px 6.7px hsl(0deg 0% 0% / 40%)",
                  }}
                />
              </Button>
              {columns[columnIndex].type !== "nofilter" &&
                filterType === "select" && (
                  <CustomMenu
                    column={tmpColumns[columnIndex]}
                    setRadioValue={handleRadioChange}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    radioValue={radioValue}
                    classes={classes}
                  >
                    <SelectFilterHead
                      handleSelectAll={handleSelectAll}
                      tmpColumns={tmpColumns}
                      checkboxHandle={checkboxHandle}
                      checked={tmpColumns[columnIndex]?.filterType}
                      columnIndex={tmpColumnIndex}
                      handleApplyFilters={handleApplyFilters}
                      classes={classes}
                    />
                    {Object.entries(
                      tmpColumns[tmpColumnIndex]?.filterValues ?? {},
                    ).map((item, index) => {
                      let altLabel;
                      if (tableKind === "project") {
                        switch (columns[columnIndex].name) {
                          case "project_type":
                            altLabel = appConf.entities.project_types[item[0]];
                            break;
                          case "pipeline_class":
                            for (let projectType in appConf.entities
                              .pipeline_classes) {
                              if (
                                appConf.entities.pipeline_classes[projectType][
                                  item[0]
                                ]
                              ) {
                                altLabel =
                                  appConf.entities.pipeline_classes[
                                    projectType
                                  ][item[0]];
                              }
                            }
                            break;
                          case "kit":
                            altLabel = appConf.entities.kits[item[0]]?.label;
                            break;
                          case "created_at":
                            altLabel = format(
                              new Date(item[0]),
                              "dd/MM/yyyy HH:mm",
                            );
                            break;
                          default:
                            break;
                        }
                      } else if (tableKind === "variant") {
                        if (
                          columns[columnIndex].representation.options &&
                          columns[columnIndex].representation.options
                            .component === "star-rating"
                        ) {
                          altLabel =
                            item[0] >= 0 ? (
                              <Rating
                                className={classes.starRating}
                                name="revstat"
                                readOnly
                                key={index}
                                max={4}
                                value={parseFloat(item[0])}
                                precision={0.1}
                              />
                            ) : (
                              ""
                            );
                        } else if (
                          columns[columnIndex].representation.options &&
                          columns[columnIndex].representation.options
                            .component === "shared_variants"
                        ) {
                          altLabel = (
                            <SharedVariants
                              data={item[0].replaceAll("'", '"')}
                            />
                          );
                        } else if (
                          columns[columnIndex].representation.options &&
                          columns[columnIndex].representation.options
                            .component_choices &&
                          columns[columnIndex].representation.options
                            .component_choices.constructor === Object
                        ) {
                          altLabel = (
                            <span
                              className={clsx({
                                [classes["green[500]"]]:
                                  item[0] === "6" || item[0] === "B",
                                [classes["lightGreen[500]"]]:
                                  item[0] === "5" || item[0] === "LB",
                                [classes["yellow[600]"]]:
                                  item[0] === "4" || item[0] === "VUS",
                                [classes["amber[500]"]]:
                                  item[0] === "3" || item[0] === "VUSi",
                                [classes["orange[500]"]]:
                                  item[0] === "2" || item[0] === "VUSii",
                                [classes["red[500]"]]:
                                  item[0] === "1" || item[0] === "LP",
                                [classes["red[900]"]]:
                                  item[0] === "0" || item[0] === "P",
                              })}
                            >
                              {columns[columnIndex].representation.options
                                .component_choices[item[0]] ?? item[0]}
                            </span>
                          );
                        }
                      }
                      if (!["<empty>", "<unary>", "<many>"].includes(item[0])) {
                        return (
                          <MenuItem
                            onClick={(e) => handleSelect(e, item[0])}
                            key={index}
                            data-index={index}
                          >
                            <Checkbox
                              checked={item[1]}
                              inputProps={{ "aria-labelledby": index }}
                            />
                            {altLabel ?? t(item[0])}
                          </MenuItem>
                        );
                      } else return null;
                    })}
                  </CustomMenu>
                )}
              {columns[columnIndex].type !== "nofilter" &&
                filterType === "search" && (
                  <CustomMenu
                    radioValue={radioValue}
                    setRadioValue={handleRadioChange}
                    column={tmpColumns[columnIndex]}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    classes={classes}
                  >
                    <SelectFilterHead
                      handleSelectAll={handleSelectAll}
                      tmpColumns={tmpColumns}
                      columnIndex={tmpColumnIndex}
                      checked={tmpColumns[columnIndex]?.filterType}
                      isApply
                      checkboxHandle={checkboxHandle}
                      handleApplyFilters={handleApplyFilters}
                      classes={classes}
                    />
                    <MenuItem onKeyDown={(e) => e.stopPropagation()}>
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          gap: 8,
                        }}
                      >
                        <VirtualizedAutocomplete
                          appConf={appConf}
                          handleSelectFilteredAll={handleSelectFilteredAll}
                          tableKind={tableKind}
                          classes={classes}
                          columns={tmpColumns}
                          columnIndex={tmpColumnIndex}
                          handleChange={handleAutocompleteChange}
                          options={Object.keys(
                            tmpColumns[tmpColumnIndex]?.filterValues,
                          )}
                          controlledValue={autoCompleteValue}
                        />
                        <HandleApplyFiltersComponent
                          handleApplyFilters={handleApplyFilters}
                          classes={classes}
                        />
                      </Box>
                    </MenuItem>
                  </CustomMenu>
                )}
              {columns[columnIndex].type !== "nofilter" &&
                filterType === "range" && (
                  <CustomMenu
                    radioValue={radioValue}
                    setRadioValue={handleRadioChange}
                    column={tmpColumns[columnIndex]}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    classes={classes}
                  >
                    <RangeFilter
                      min={
                        Math.ceil(
                          columns[columnIndex].minValue * Math.pow(10, 3),
                        ) / Math.pow(10, 3)
                      }
                      max={
                        Math.ceil(
                          columns[columnIndex].maxValue * Math.pow(10, 3),
                        ) / Math.pow(10, 3)
                      }
                      value={activeRange}
                      step={
                        columns[columnIndex].representation.options
                          ?.range_step ?? rangeStep
                      }
                      onChange={handleRangeChange}
                      onApply={handleApplyRange}
                    />
                  </CustomMenu>
                )}
              {columns[columnIndex].type !== "nofilter" &&
                filterType === "boolean" && (
                  <CustomMenu
                    radioValue={radioValue}
                    setRadioValue={handleRadioChange}
                    column={tmpColumns[columnIndex]}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    classes={classes}
                  >
                    <SelectFilterHead
                      handleSelectAll={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleBoolean(e, tmpColumns[columnIndex], {
                          true: false,
                          false: false,
                        });
                      }}
                      isDelete={true}
                      tmpColumns={tmpColumns}
                      columnIndex={tmpColumnIndex}
                      checked={tmpColumns[columnIndex]?.filterType}
                      checkboxHandle={checkboxHandle}
                      handleApplyFilters={handleApplyFilters}
                      classes={classes}
                    />
                    <BooleanItems
                      handleBoolean={handleSelect}
                      tmpColumns={tmpColumns}
                      columnIndex={columnIndex}
                    />
                  </CustomMenu>
                )}
            </div>
          )}
      </div>
    </div>
  );
};

export const BooleanItems = ({ handleBoolean, tmpColumns, columnIndex }) => {
  const filters = tmpColumns[columnIndex]?.representation?.options?.filters || {
    true: {
      tr: "Etiketli",
      en_GB: "Tagged",
    },
    false: {
      tr: "Etiketsiz",
      en_GB: "Untagged",
    },
  };

  if (filters) {
    return Object.entries(filters).map((filter, index) => {
      return (
        <MenuItem
          key={index}
          onClick={(e) => {
            const boolean =
              filter[0] === "True" ||
              filter[0] === "true" ||
              filter[0] === true;
            handleBoolean(e, filter[0]);
          }}
        >
          <Checkbox
            checked={
              !isEmpty(tmpColumns[columnIndex]?.filterValues)
                ? tmpColumns[columnIndex]?.filterValues[filter[0]]
                : null
            }
          />
          {getTranslated(filter[1])}
        </MenuItem>
      );
    });
  }
};

const CustomMenu = ({
  column,
  anchorEl,
  handleClose,
  classes,
  children,
  handleSelect,
  setRadioValue,
  radioValue,
}) => {
  return (
    <Menu
      id="simple-menu"
      onClick={(event) => event.stopPropagation()}
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      className={classes.sliderMenu}
    >
      {children}
      {column.multi_value &&
        (column?.kind === "enumeration" ||
          column?.kind === "large_enum" ||
          column?.kind === "numeric") && (
          <FormGroup
            row
            style={{ justifyContent: "space-between", padding: "0px 16px" }}
          >
            {/* <FormControlLabel
              labelPlacement="bottom"
              onChange={setRadioValue}
              value="<empty>"
              control={<Checkbox checked={radioValue["<empty>"]} />}
              label="Empty"
              name="empty"
            />
            <FormControlLabel
              labelPlacement="bottom"
              onChange={setRadioValue}
              value="<unary>"
              control={<Checkbox checked={radioValue["<unary>"]} />}
              label="Unary"
              name="unary"
            />
            <FormControlLabel
              labelPlacement="bottom"
              onChange={setRadioValue}
              value="<many>"
              control={<Checkbox checked={radioValue["<many>"]} />}
              label="Many"
              name="many"
            /> */}
          </FormGroup>
        )}
    </Menu>
  );
};

const RangeFilter = ({ min, max, value, onApply }) => {
  const classes = useStyle();
  const { t } = useTranslation();

  // Helper function that formats number with 3 decimal places
  const formatDecimal = (value) => {
    if (value === "" || value === undefined || value === null) return "";
    if (
      value === "-" ||
      value === "." ||
      value === "-." ||
      /^-?\d+\.$/.test(value)
    )
      return value;
    const number = Math.ceil(value * Math.pow(10, 3)) / Math.pow(10, 3);
    if (isNaN(number)) return value;
    return number === 0 ? "0" : Number(number.toFixed(3)).toString();
  };

  const [localValue, setLocalValue] = useState([
    value[0] === min ? "" : formatDecimal(value[0]),
    formatDecimal(value[1]),
  ]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setLocalValue([
      value[0] === min ? "" : formatDecimal(value[0]),
      formatDecimal(value[1]),
    ]);
  }, [value, min]);

  const handleInputChange = (type) => (event) => {
    let inputValue = event.target.value;

    if (inputValue === "") {
      setLocalValue(type === "min" ? ["", localValue[1]] : [localValue[0], ""]);
      return;
    }

    if (!/^-?\d*\.?\d*$/.test(inputValue)) return;

    if (
      inputValue === "-" ||
      inputValue === "." ||
      inputValue === "-." ||
      /^-?\d+\.$/.test(inputValue)
    ) {
      setLocalValue(
        type === "min"
          ? [inputValue, localValue[1]]
          : [localValue[0], inputValue],
      );
      return;
    }

    if (inputValue.includes(".")) {
      const [whole, decimal] = inputValue.split(".");
      if (decimal?.length > 3) {
        inputValue = formatDecimal(`${whole}.${decimal}`);
      }
    }

    setLocalValue(
      type === "min"
        ? [inputValue, localValue[1]]
        : [localValue[0], inputValue],
    );
  };

  const handleApplyClick = () => {
    const minValue =
      localValue[0] === ""
        ? Math.ceil(min * Math.pow(10, 3)) / Math.pow(10, 3)
        : parseFloat(localValue[0]);
    const maxValue =
      localValue[1] === ""
        ? Math.ceil(max * Math.pow(10, 3)) / Math.pow(10, 3)
        : parseFloat(localValue[1]);
    const errors = [];

    if (minValue > max) {
      errors.push(t("Minimum value cannot be greater than maximum value"));
    }

    if (maxValue > max) {
      errors.push(
        t("The entered value is greater than the maximum allowed value."),
      );
    }

    if (minValue > maxValue) {
      errors.push(
        t("Minimum value cannot be greater than selected maximum value"),
      );
    }

    if (errors.length > 0) {
      errors.forEach((error) => {
        enqueueSnackbar(error, {
          variant: "warning",
          autoHideDuration: 3000,
        });
      });
      return;
    }

    onApply([minValue, maxValue]);
  };

  return (
    <Box className={classes.rangeFilterContainer}>
      <Box className={classes.inputContainer}>
        <Box className={classes.inputWrapper}>
          <TextField
            className={classes.numberInput}
            type="text"
            label={t("Min")}
            value={localValue[0]}
            onChange={handleInputChange("min")}
            inputProps={{
              inputMode: "decimal",
            }}
          />
          <Typography className={classes.helperText}>
            {t("Min")}: {formatDecimal(min)}
          </Typography>
        </Box>
        <Box className={classes.inputWrapper}>
          <TextField
            className={classes.numberInput}
            type="text"
            label={t("Max")}
            value={localValue[1]}
            onChange={handleInputChange("max")}
            inputProps={{
              inputMode: "decimal",
            }}
          />
          <Typography className={classes.helperText}>
            {t("Max")}: {formatDecimal(max)}
          </Typography>
        </Box>
      </Box>
      <Button
        className={classes.applyButton}
        variant="contained"
        fullWidth
        onClick={handleApplyClick}
      >
        {t("Apply")}
      </Button>
    </Box>
  );
};
